module.exports = window["core-js/modules/es.array.join.js"];